(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-content-tabs"] && !Shopify.designMode) return;
  try {
    
  class TabContent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab-selector]'));
      this.contents = Array.from(this.querySelectorAll('[data-tab-content]'));
      this.container = this.querySelector('[data-tab-selector-container]');
      this.track = this.querySelector('[data-tab-track]');
      this.leftArrow = this.querySelector('[data-scroll-arrow="left"]');
      this.rightArrow = this.querySelector('[data-scroll-arrow="right"]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.swiper = null;

      this.onBreakpoint = () => this.syncSwiper();

      this.leftArrow?.addEventListener('click', () => this.activate(Math.max(this.currentPosition() - 1, 0)));
      this.rightArrow?.addEventListener('click', () =>
        this.activate(Math.min(this.currentPosition() + 1, this.tabs.length - 1))
      );
      this.tabs.forEach((tab, position) => tab.addEventListener('click', () => this.activate(position)));
      this.mobileQuery.addEventListener?.('change', this.onBreakpoint);

      this.syncSwiper();
      this.updateArrowVisibility();
    }

    disconnectedCallback() {
      this.mobileQuery.removeEventListener?.('change', this.onBreakpoint);
      this.destroySwiper();
    }

    activeIndex() {
      const tab = this.tabs[this.currentPosition()];
      return tab ? Number(tab.dataset.tabSelector) : 0;
    }

    currentPosition() {
      return this.tabs.findIndex((t) => t.classList.contains('active'));
    }

    syncSwiper() {
      if (this.mobileQuery.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiper || !this.track || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(this.track, {
        slidesPerView: 1,
        speed: this.reducedMotion.matches ? 0 : 300,
        spaceBetween: 36,
        autoHeight: true,
        grabCursor: true,
        initialSlide: this.activeIndex(),
        on: {
          slideChange: (swiper) => {
            const position = this.tabs.findIndex((t) => t.dataset.tabSelector === String(swiper.activeIndex));
            if (position !== -1 && position !== this.currentPosition()) this.activate(position, { slide: false });
          },
        },
      });

      document.fonts?.ready.then(() => this.swiper?.updateAutoHeight());
    }

    destroySwiper() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    activate(position, { slide = true } = {}) {
      const tab = this.tabs[position];
      if (!tab) return;

      this.tabs.forEach((t) => t.classList.toggle('active', t === tab));
      this.contents.forEach((c) => c.classList.toggle('is-inactive', c.dataset.tabContent !== tab.dataset.tabSelector));

      this.scrollSelectorIntoView(tab);
      this.updateArrowVisibility();

      if (slide && this.swiper) this.swiper.slideTo(Number(tab.dataset.tabSelector));
    }

    scrollSelectorIntoView(tab) {
      if (!this.container) return;
      this.container.scrollTo({
        left: tab.offsetLeft - this.container.offsetLeft - 30,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
      });
    }

    updateArrowVisibility() {
      if (!this.leftArrow || !this.rightArrow) return;

      const position = this.currentPosition();
      this.leftArrow.classList.toggle('visible', position > 0);
      this.rightArrow.classList.toggle('visible', position < this.tabs.length - 1);
    }
  }

  customElements.define('tab-content', TabContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
